/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemTaxFull,
  ItemTaxFullOptional,
  ItemTaxFullMetaI,
  ItemTaxFullTrackedI,
} from "./item-tax-full";
import { ItemTaxFullTracked, ItemTaxFullMeta } from "./item-tax-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TaxRef,
  TaxRefOptional,
  TaxRefMetaI,
  TaxRefTrackedI,
} from "./tax-ref";
import { TaxRefTracked, TaxRefMeta } from "./tax-ref";

/**
 *
 * @export
 * @interface CatalogItemTaxDTO
 */
export interface CatalogItemTaxDTOOptional extends ItemTaxFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemTaxDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemTaxDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemTaxDTO
   */
  assignId?: number;
  /**
   *
   * @type {TaxRef}
   * @memberof CatalogItemTaxDTO
   */
  taxId?: TaxRefOptional;
}

export interface CatalogItemTaxDTO
  extends CatalogItemTaxDTOOptional, ItemTaxFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemTaxDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemTaxDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemTaxDTO
   */
  assignId: number;
  /**
   *
   * @type {TaxRef}
   * @memberof CatalogItemTaxDTO
   */
  taxId?: TaxRef;
}

export interface CatalogItemTaxDTOTrackedI extends ItemTaxFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemTaxDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemTaxDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemTaxDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {TaxRef}
   * @memberof CatalogItemTaxDTO
   */
  taxId?: TaxRefTrackedI;
  taxIdIsSet: boolean;
}

transformDatesMap.set("CatalogItemTaxDTO", function (model: CatalogItemTaxDTO) {
  const transformDatestaxId = transformDatesMap.get("TaxRef");
  if (transformDatestaxId && model.taxId) {
    transformDatestaxId(model.taxId);
  }
});

export type CatalogItemTaxDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxId: PropertyMeta<TaxRefMetaI>;
}>;

export var CatalogItemTaxDTOMeta: CatalogItemTaxDTOMetaI =
  {} as CatalogItemTaxDTOMetaI;
CatalogItemTaxDTOMeta = typeMeta("CatalogItemTaxDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  taxId: propertyMeta("taxId", false, false, false, TaxRefMeta),
});

const metaI = CatalogItemTaxDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemTaxFullMeta]);
  metaI.isDeleted.inheritedFrom = ItemTaxFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ItemTaxFullMeta.isNew;
  metaI.assignId.inheritedFrom = ItemTaxFullMeta.assignId;
  metaI.taxId.inheritedFrom = ItemTaxFullMeta.taxId;
});

export class CatalogItemTaxDTOTracked
  extends ItemTaxFullTracked
  implements CatalogItemTaxDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  taxId__I?: TaxRefTracked = undefined;
  taxIdIsSet: boolean = false;
  set taxId(v: undefined | TaxRefTracked) {
    if (v !== undefined) {
      this.taxId__I = v;
      this.taxIdIsSet = true;
    } else {
      this.taxId__I = v || undefined;
      this.taxIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxId() {
    return this.taxId__I;
  }
  constructor(config?: CatalogItemTaxDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.taxId?.setIds();
  }
  assignFrom(
    config: CatalogItemTaxDTOOptional,
    options?: AssignOptions,
  ): CatalogItemTaxDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.taxId && this.taxIdApplyFilter(optionsRequired.filter)) {
      this.taxId = new TaxRefTracked(config.taxId, options);
      if (optionsRequired.unassign) this.taxIdIsSet = false;
      else this.taxIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemTaxDTOTrackedI {
    const cloned = {} as CatalogItemTaxDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.taxIdIsSetDeep() &&
      this.taxIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxIdIsSet = true;
      cloned.taxId = this.taxId?.removeUnset(filter);
    } else {
      //cloned.taxIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemTaxDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.taxIdApplyFilter(filter)) this.taxIdIsSet = false;
    this.taxId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemTaxDTOMeta.isDeleted,
      CatalogItemTaxDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemTaxDTOMeta.isNew,
      CatalogItemTaxDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemTaxDTOMeta.assignId,
      CatalogItemTaxDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  taxIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemTaxDTOMeta.taxId,
      CatalogItemTaxDTOMeta,
      this.taxId,
      this,
    );
  }
  taxIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxIdIsSet && this.taxIdApplyFilter(filter)) return true;
    return this.taxId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.taxIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
